import { memo, useEffect } from 'react';
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { addPointsInText } from '../../../../helpers/app';
import { PublicationVersionSelectorProps } from '../../interfaces';
import styles from '../../publicationDetail.module.scss';

const PublicationVersionSelector = ({
  publication,
  selectedVersion,
  setSelectedVersion,
  type,
  vehicleTypeSelected,
  brand
}: PublicationVersionSelectorProps) => {
  const vehicles = publication?.versions || [];
  const sortedVehicles = [...vehicles].sort((a, b) => (a.price || 0) - (b.price || 0));
  

  useEffect(() => {
    if (sortedVehicles.length > 0 && setSelectedVersion && vehicleTypeSelected === "new" && brand) {
      const firstVehicleId = sortedVehicles[0].id || sortedVehicles[0]._id;
      
      const isValidSelection = selectedVersion && sortedVehicles.some(v => (v.id || v._id) === selectedVersion);
      
      if (!selectedVersion || !isValidSelection) {
        setSelectedVersion(firstVehicleId);
      }
    }
  }, [sortedVehicles, selectedVersion, setSelectedVersion, vehicleTypeSelected, brand]);

  // Early returns after hooks
  if (vehicleTypeSelected !== "new" || !brand) {
    return null;
  }
  
  if (type === "myPublication" && !brand) {
    return null;
  }

  if (vehicles.length === 0) {
    return null;
  }

  const handleVersionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    if (setSelectedVersion) {
      setSelectedVersion(newValue);
    }
  };

  return (
    <div className={styles.versionSelector}>
      <h3 className={styles.selectorTitle}>Selecciona la versión</h3>
      <FormControl component="fieldset" fullWidth>
        <RadioGroup
          name="vehicleVersion"
          value={selectedVersion || ''}
          onChange={handleVersionChange}
        >
          {sortedVehicles.map((vehicle: any) => {
            const vehicleId = vehicle.id || vehicle._id;
            const isSelected = selectedVersion === vehicleId;            
            return (
              <div
                className={`${styles.versionCardContainer} ${isSelected ? styles.selectedVersion : ''}`}
                key={vehicleId}
              >
                <FormControlLabel
                  value={vehicleId}
                  control={<Radio />}
                  className={styles.versionRadio}
                  label={
                    <div className={styles.versionOption}>
                      <div className={styles.versionName}>
                        {vehicle.version || vehicle.name || `${vehicle.year} ${vehicle.model}`}
                      </div>
                      <div className={styles.versionPrice}>
                        ${addPointsInText(vehicle.price)}
                      </div>
                    </div>
                  }
                />
              </div>
            );
          })}
        </RadioGroup>
      </FormControl>
    </div>
  );
};

export default memo(PublicationVersionSelector);
